import { View } from 'react-native';
import { Colors } from '../../themes/colors';
import { themedStyleSheet } from '../../themes/themedStyleSheet';

export type Step = {
  key: string;
  title: string;
  description: string[];
  image: string;
  label: string;
};

type StepperProps = {
  activeStep: number;
  steps: string[];
};

export const Stepper = ({ activeStep, steps }: StepperProps) => {
  return (
    <View style={styles.container}>
      {steps.map((step, index) => (
        <View
          key={`step-${step?.trim()}-${index}`}
          style={[styles.step, index <= activeStep && styles.filled]}
        />
      ))}
    </View>
  );
};

const styles = themedStyleSheet((role) => ({
  container: {
    flexDirection: 'row',
    gap: 10,
    alignItems: 'center',
    alignSelf: 'center',
    marginBottom: 60,
  },
  step: {
    width: 10,
    height: 10,
    backgroundColor: role.borderStrong,
    borderRadius: 5,
  },
  filled: {
    backgroundColor: Colors.primary,
  },
}));
